<div class="tw-flex tw-flex-col tw-gap-6 tw-pb-4">
  <!-- Amount being converted -->
  <div
    class="tw-flex tw-flex-col tw-gap-1 tw-rounded-2xl tw-bg-dt-surface-card tw-p-4 tw-shadow-elevation-card"
  >
    <span class="tw-text-xs tw-font-medium tw-uppercase tw-text-dt-text-secondary"
      >Platinum to convert</span
    >
    <div
      class="tw-flex tw-h-14 tw-items-center tw-justify-between tw-rounded-xl tw-bg-color-surface-input tw-px-4 tw-py-3"
    >
      <span
        class="tw-font-D-DIN-PRO tw-text-2xl tw-font-semibold tw-text-dt-text-headings"
        data-testid="confirm-amount"
        >{{ amount }}</span
      >
      <span class="tw-text-xs tw-font-medium tw-uppercase tw-text-dt-text-secondary">Platinum</span>
    </div>
  </div>

  <!-- Gold you will receive (client-side estimate) -->
  <div
    class="tw-flex tw-flex-col tw-gap-1 tw-rounded-2xl tw-bg-dt-surface-card tw-p-4 tw-shadow-elevation-card"
  >
    <span class="tw-text-xs tw-font-medium tw-uppercase tw-text-dt-text-secondary"
      >You get · Gold</span
    >
    <div
      class="tw-flex tw-h-14 tw-items-center tw-justify-end tw-gap-4 tw-rounded-2xl tw-bg-[linear-gradient(174deg,rgba(0,196,196,0.10),rgba(0,128,129,0.06))] tw-px-4 tw-py-3 tw-shadow-[0px_3px_12px_0px_rgba(0,128,129,0.09),inset_0px_1px_0px_0px_var(--glass-highlight)] dark:tw-shadow-[inset_0px_1px_0px_0px_var(--glass-highlight)] tw-outline tw-outline-1 tw-outline-offset-[-1px] tw-outline-[rgba(0,196,196,0.22)]"
    >
      <span
        class="tw-font-D-DIN-PRO tw-flex-1 tw-text-2xl tw-font-semibold tw-text-dt-text-headings"
        data-testid="confirm-gold"
        >{{ goldEstimate }}</span
      >
      <span class="tw-text-xs tw-font-medium tw-uppercase tw-text-dt-text-secondary">Gold</span>
    </div>
  </div>

  <!-- Actions -->
  <div class="tw-flex tw-flex-col tw-gap-3">
    <button
      type="button"
      (click)="onConfirm()"
      [disabled]="confirming()"
      aria-label="Confirm conversion"
      data-testid="confirm-button"
      class="tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-rounded-2xl tw-bg-button-glass-accent-bg tw-text-base tw-font-semibold tw-text-button-glass-accent-label tw-shadow-elevation-card disabled:tw-opacity-50"
    >
      Confirm
    </button>
    <button
      type="button"
      (click)="onCancel()"
      aria-label="Cancel conversion"
      data-testid="cancel-button"
      class="tw-flex tw-h-12 tw-w-full tw-items-center tw-justify-center tw-rounded-2xl tw-bg-color-surface-sunken tw-text-base tw-font-semibold tw-text-dt-text-secondary"
    >
      Cancel
    </button>
  </div>
</div>
